const styles = {
  quoteContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    width: '100vw',
    height: '100vh',
  },
  quoteCard: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    justifySelf: 'center',
    maxWidth: '50%',
    lineHeight: '1.6'
  },
  quoteAuthor: {
    alignSelf: 'flex-end',
    justifySelf: 'flex-end',
    maxWidth: 'fit-content',
  }
};

export default styles;